import React, { useState } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Image as PrimeImage } from 'primereact/image';


const CarouselImage = ({ item, shopName, isMap, mapOptions, center, onMapError }) => {
  const [isLoading, setIsLoading] = useState(!isMap);
  const [error, setError] = useState(false);

  if (isMap) {
    return (
      <div className="carousel-image-container">
        <GoogleMap
          mapContainerStyle={{ width: '100%', height: '100%' }}
          center={center}
          zoom={15}
          options={mapOptions}
          onError={onMapError}
        >
          <Marker position={center} />
        </GoogleMap>
      </div>
    );
  }

  return (
    <div
      className="carousel-image-card"
      style={{
        width: '100%',
        maxWidth: 340,
        height: 240,
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 2px 8px rgba(87,124,247,0.08)',
        overflow: 'hidden',
        position: 'relative',
        margin: '0 auto',
        padding: 0
      }}
    >
      <div 
        className="carousel-image-container" 
        style={{ 
          width: '100%', 
          height: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa'
        }}
      >
        {isLoading && (
          <div 
            className="image-loading" 
            style={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              zIndex: 1
            }}
          >
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
          </div>
        )}
        {error ? (
          <div 
            className="image-error" 
            style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              justifyContent: 'center', 
              width: '100%',
              height: '100%',
              padding: '1rem',
              textAlign: 'center'
            }}
          >
            <i className="pi pi-image" style={{ fontSize: '2rem', marginBottom: '0.5rem' }}></i>
            <p style={{ margin: 0 }}>Failed to load image</p>
          </div>
        ) : (
          <PrimeImage
            src={item}
            alt={shopName}
            className="carousel-image"
            preview
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              borderRadius: 0,
              display: 'block'
            }}
            imageStyle={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
            onLoad={() => setIsLoading(false)}
            onError={() => {
              setIsLoading(false);
              setError(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CarouselImage; 